/**
 * The shortest outreach window a member may set, in minutes. The backend
 * refuses a shorter one; the settings form offers no end that would make one.
 */
export const MIN_OUTREACH_WINDOW_MINUTES = 60;
